import { api } from "@/planner/lib/apiClient";

// Your own product photo: shrunk to 800px JPEG in the browser (phone photos are several MB), then
// stored on the server (POST /products/{id}/photo-upload). Returns the updated product.
export const photoToDataUrl = (file, max = 800) => new Promise((resolve, reject) => {
  if (!file || !file.type.startsWith("image/")) { reject(new Error("Pick a photo.")); return; }
  const reader = new FileReader();
  reader.onerror = () => reject(new Error("Couldn't read that photo."));
  reader.onload = () => {
    const img = new Image();
    img.onerror = () => reject(new Error("Couldn't open that photo. Try a JPEG or PNG."));
    img.onload = () => {
      const scale = Math.min(1, max / Math.max(img.width, img.height));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL("image/jpeg", 0.85));
    };
    img.src = reader.result;
  };
  reader.readAsDataURL(file);
});

export const uploadProductPhoto = async (productId, fileOrDataUrl) => {
  const data = typeof fileOrDataUrl === "string" ? fileOrDataUrl : await photoToDataUrl(fileOrDataUrl);
  return (await api.post(`/products/${productId}/photo-upload`, { data })).data;
};
